import SpeakButton from "../EnglishTool/SpeakButton.js";

export const chapterPages = {
  1: [
    {
      title: <h2>Phonics – Overview</h2>,
      body: (
        <>
          <p>
            Phonics helps children understand how letters make sounds. Learning
            phonics makes it easier to read words!
          </p>
          <p>
            <strong>Example:</strong> The letter “C” in "cat"
            <SpeakButton text="cat" />
            makes the “k” sound.
          </p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>Letters represent sounds: C = /k/, G can be /g/ or /j/, etc.</li> 
            <li>Blend sounds to read words: /c/ + /a/ + /t/ = “cat.”</li>
            <li>Practice reading simple words daily to get comfortable.</li>
            <li>Phonics is the first step to reading bigger words & sentences!</li>
          </ul>
        </>
      ),
    },

    // A
    {
      title: <h2>Phonics – A</h2>,
      body: (
        <>
          <p>This is how A sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Apple.png"
                alt="Apple"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>A</strong> – <em>Apple</em>{" "}
                <SpeakButton text="A" />
                <SpeakButton text="Apple" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // B
    {
      title: <h2>Phonics – B</h2>,
      body: (
        <>
          <p>This is how B sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Basketball.png"
                alt="Basketball"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>B</strong> – <em>Basketball</em>{" "}
                <SpeakButton text="B" />
                <SpeakButton text="Basketball" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // C
    {
      title: <h2>Phonics – C</h2>,
      body: (
        <>
          <p>This is how C sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Cat.png"
                alt="Cat"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>C</strong> – <em>Cat</em>{" "}
                <SpeakButton text="C" />
                <SpeakButton text="Cat" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // D
    {
      title: <h2>Phonics – D</h2>,
      body: (
        <>
          <p>This is how D sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Dog.png"
                alt="Dog"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>D</strong> – <em>Dog</em>{" "}
                <SpeakButton text="D" />
                <SpeakButton text="Dog" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // E
    {
      title: <h2>Phonics – E</h2>,
      body: (
        <>
          <p>This is how E sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Egg.png"
                alt="Egg"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>E</strong> – <em>Egg</em>{" "}
                <SpeakButton text="E" />
                <SpeakButton text="Egg" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // F
    {
      title: <h2>Phonics – F</h2>,
      body: (
        <>
          <p>This is how F sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Fish.png"
                alt="Fish"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>F</strong> – <em>Fish</em>{" "}
                <SpeakButton text="F" />
                <SpeakButton text="Fish" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // G
    {
      title: <h2>Phonics – G</h2>,
      body: (
        <>
          <p>This is how G sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Goat.png"
                alt="Goat"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>G</strong> – <em>Goat</em>{" "}
                <SpeakButton text="G" />
                <SpeakButton text="Goat" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // H
    {
      title: <h2>Phonics – H</h2>,
      body: (
        <>
          <p>This is how H sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Hat.png"
                alt="Hat"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>H</strong> – <em>Hat</em>{" "}
                <SpeakButton text="H" />
                <SpeakButton text="Hat" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // I
    {
      title: <h2>Phonics – I</h2>,
      body: (
        <>
          <p>This is how I sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Igloo.png"
                alt="Igloo"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>I</strong> – <em>Igloo</em>{" "}
                <SpeakButton text="I" />
                <SpeakButton text="Igloo" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // J
    {
      title: <h2>Phonics – J</h2>,
      body: (
        <>
          <p>This is how J sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Jam.png"
                alt="Jam"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>J</strong> – <em>Jam</em>{" "}
                <SpeakButton text="J" />
                <SpeakButton text="Jam" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // K
    {
      title: <h2>Phonics – K</h2>,
      body: (
        <>
          <p>This is how K sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Key.png"
                alt="Key"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>K</strong> – <em>Key</em>{" "}
                <SpeakButton text="K" />
                <SpeakButton text="Key" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // L
    {
      title: <h2>Phonics – L</h2>,
      body: (
        <>
          <p>This is how L sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Lion.png"
                alt="Lion"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>L</strong> – <em>Lion</em>{" "}
                <SpeakButton text="L" />
                <SpeakButton text="Lion" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // M
    {
      title: <h2>Phonics – M</h2>,
      body: (
        <>
          <p>This is how M sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Milk.png"
                alt="Milk"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>M</strong> – <em>Milk</em>{" "}
                <SpeakButton text="M" />
                <SpeakButton text="Milk" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // N
    {
      title: <h2>Phonics – N</h2>,
      body: (
        <>
          <p>This is how N sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Nose.png"
                alt="Nose"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>N</strong> – <em>Nose</em>{" "}
                <SpeakButton text="N" />
                <SpeakButton text="Nose" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // O
    {
      title: <h2>Phonics – O</h2>,
      body: (
        <>
          <p>This is how O sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Orange.png"
                alt="Orange"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>O</strong> – <em>Orange</em>{" "}
                <SpeakButton text="O" />
                <SpeakButton text="Orange" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // P
    {
      title: <h2>Phonics – P</h2>,
      body: (
        <>
          <p>This is how P sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Pizza.png"
                alt="Pizza"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>P</strong> – <em>Pizza</em>{" "}
                <SpeakButton text="P" />
                <SpeakButton text="Pizza" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // Q
    {
      title: <h2>Phonics – Q</h2>,
      body: (
        <>
          <p>This is how Q sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Queen.png"
                alt="Queen"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>Q</strong> – <em>Queen</em>{" "}
                <SpeakButton text="Q" />
                <SpeakButton text="Queen" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // R
    {
      title: <h2>Phonics – R</h2>,
      body: (
        <>
          <p>This is how R sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Rat.png"
                alt="Rat"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>R</strong> – <em>Rat</em>{" "}
                <SpeakButton text="R" />
                <SpeakButton text="Rat" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // S
    {
      title: <h2>Phonics – S</h2>,
      body: (
        <>
          <p>This is how S sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Sun.png"
                alt="Sun"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>S</strong> – <em>Sun</em>{" "}
                <SpeakButton text="S" />
                <SpeakButton text="Sun" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // T
    {
      title: <h2>Phonics – T</h2>,
      body: (
        <>
          <p>This is how T sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Toy.png"
                alt="Toy"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>T</strong> – <em>Toy</em>{" "}
                <SpeakButton text="T" />
                <SpeakButton text="Toy" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // U
    {
      title: <h2>Phonics – U</h2>,
      body: (
        <>
          <p>This is how U sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Umbrella.png"
                alt="Umbrella"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>U</strong> – <em>Umbrella</em>{" "}
                <SpeakButton text="U" />
                <SpeakButton text="Umbrella" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // V
    {
      title: <h2>Phonics – V</h2>,
      body: (
        <>
          <p>This is how V sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Van.png"
                alt="Van"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>V</strong> – <em>Van</em>{" "}
                <SpeakButton text="V" />
                <SpeakButton text="Van" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // W
    {
      title: <h2>Phonics – W</h2>,
      body: (
        <>
          <p>This is how W sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Water.png"
                alt="Water"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>W</strong> – <em>Water</em>{" "}
                <SpeakButton text="W" />
                <SpeakButton text="Water" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // X
    {
      title: <h2>Phonics – X</h2>,
      body: (
        <>
          <p>This is how X sounds! (Often at the end of words, e.g., “Box”)</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/X-Ray.png"
                alt="X-Ray"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>X</strong> – <em>X-Ray</em>{" "}
                <SpeakButton text="X" />
                <SpeakButton text="X-Ray" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // Y
    {
      title: <h2>Phonics – Y</h2>,
      body: (
        <>
          <p>This is how Y sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Yellow.png"
                alt="Yellow"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>Y</strong> – <em>Yellow</em>{" "}
                <SpeakButton text="Y" />
                <SpeakButton text="Yellow" />
              </div>
            </li>
          </ul>
        </>
      ),
    },

    // Z
    {
      title: <h2>Phonics – Z</h2>,
      body: (
        <>
          <p>This is how Z sounds!</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li className="phonics-item">
              <img
                src="/images/Phonics/Zebra.png"
                alt="Zebra"
                style={{ marginRight: "15px" }}
              />
              <div>
                <strong>Z</strong> – <em>Zebra</em>{" "}
                <SpeakButton text="Z" />
                <SpeakButton text="Zebra" />
              </div>
            </li>
          </ul>
        </>
      ),
    },
  ],
  

  2: [
    {
      title: <h2>Sight Words – What Are They?</h2>,
      body: (
        <>
          <p>
            Sight words are special words you can read quickly, without sounding
            out each letter. For example: <em>the</em>, <em>and</em>, or{" "}
            <em>can</em>. <SpeakButton text="The, And, Can" />
          </p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              They appear often in stories (like <em>the</em>, <em>of</em>,{" "}
              <em>you</em>). <SpeakButton text="The, of, you" />
            </li>
            <li>
              Sometimes they match simple sounds (like <em>and</em> = A–N–D),
              but sometimes they don’t (like <em>said</em>).
            </li>
          </ul>
        </>
      ),
    },
  
    {
      title: <h2>Why Learn Sight Words?</h2>,
      body: (
        <>
          <p>
            When you know sight words instantly, you can read much <strong>faster</strong>{" "}
            and <strong>smoother</strong>!
          </p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              You won’t have to stop and sound out every letter in <em>the</em>{" "}
              or <em>they</em>.
            </li>
            <li>
              You’ll understand stories more easily if you recognize words “at a
              glance.”
            </li>
          </ul>
        </>
      ),
    },
  
    {
      title: <h2>Connection to Phonics</h2>,
      body: (
        <>
          <p>
            From <strong>Chapter 1</strong>, you learned that each letter (like{" "}
            <em>A</em> for <em>Apple</em>) has its sound. This can help you
            with some sight words—like <em>can</em> or <em>it</em>—because they
            match how they’re spelled.
          </p>
          <p>
            But other words, like <em>the</em> or <em>was</em>, don’t sound exactly
            like their letters. That’s why we memorize them by sight!
          </p>
        </>
      ),
    },
  
    {
      title: <h2>Try Some Sight Words!</h2>,
      body: (
        <>
          <p>Let’s practice a few common sight words together:</p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              <em>the</em>{" "}
              <SpeakButton text="the" />
            </li>
            <li>
              <em>and</em>{" "}
              <SpeakButton text="and" />
            </li>
            <li>
              <em>my</em>{" "}
              <SpeakButton text="my" />
            </li>
            <li>
              <em>can</em>{" "}
              <SpeakButton text="can" />
            </li>
          </ul>
          <p>
            Try saying each word out loud without pausing for each letter.
            Good job!
          </p>
        </>
      ),
    },
  ],
  

  3: [
    // SLIDE 1: Overview & Basic Rules
    {
      title: <h2>Sentence Building – Basics</h2>,
      body: (
        <>
          <p>
            Building sentences helps us share our ideas! A sentence starts with a
            capital letter and ends with a period, question mark, or exclamation mark.
          </p>
          <p>
            <strong>Example:</strong> "I like to play outside."
            <SpeakButton text="I like to play outside." />
          </p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              <strong>Capital letter</strong> at the beginning 
              (e.g., <em>I</em>, <em>She</em>, or <em>Today</em>).
            </li> <SpeakButton text="I, She, Today " />
            <li>Spaces between words so we can see each word clearly.</li>
            <li>
              A <strong>period</strong> (.), <strong>question mark</strong> (?), 
              or <strong>exclamation mark</strong> (!) at the end.
            </li>
            <li>
              Try using some sight words from <em>Chapter 2</em> along with your 
              letter sounds from <em>Chapter 1</em>. For example, 
              <em> “I see a cat.”</em>
            </li>
          </ul>
        </>
      ),
    },
  
    // SLIDE 2: Examples & Practice
    {
      title: <h2>Sentence Building – Practice</h2>,
      body: (
        <>
          <p>
            Let’s practice putting words together into sentences. Remember to use:
          </p>
          <ul style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              A <strong>capital letter</strong> at the start (
              <SpeakButton text="Capital letter" />
              ).
            </li>
            <li>
              A <strong>full stop</strong> at the end (or a question mark 
              <SpeakButton text="Question mark" /> 
              if you’re asking something).
            </li>
          </ul>
  
          <p>Here are some fun practice ideas:</p>
          <ol style={{ textAlign: "left", marginLeft: "30px" }}>
            <li>
              <strong>Mix & Match Words:</strong> Write out words like{" "}
              <em>I, see, a, dog, cat, run, am, we</em>, then arrange them
              into short sentences. Say them out loud:
              <SpeakButton text="I see a dog" /> 
              &nbsp;or
              <SpeakButton text="We run" />.
            </li>
            <li>
              <strong>Draw & Label:</strong> Draw a picture (e.g., a sun and a tree), 
              then write a short sentence underneath, like 
              <em> “The sun is bright.”</em>
              <SpeakButton text="The sun is bright." />
            </li>
            <li>
              <strong>Question Fun:</strong> Practice asking questions: 
              <em> “Can you see the cat?”</em>
              <SpeakButton text="Can you see the cat?" />
              or <em> “Are we ready to play?”</em> 
            </li>
          </ol>
        </>
      ),
    },
  ],
  4: [
    {
      title: <h2>Basic Grammar – Nouns & Verbs</h2>,
      body: (
        <>
          <p>
            A <strong>noun</strong> is a word that names a person, place, or thing
            (like “dog”, “city”, or “ball”).
          </p>
          <p>
            A <strong>verb</strong> is an action word, like “run” or “play”.
          </p>
          <p>
            We’ll learn how to spot nouns & verbs to build better sentences!
          </p>
        </>
      )
    },
    {
      title: <h2>Basic Grammar – Practice</h2>,
      body: (
        <>
          <p>
            Try finding nouns & verbs in these short examples:
          </p>
          <ul>
            <li>
              <em>The dog runs.</em>
              <br/>
              <strong>Noun:</strong> dog. <strong>Verb:</strong> runs.
            </li>
            <li>
              <em>I play ball.</em>
              <br/>
              <strong>Nouns:</strong> I, ball. <strong>Verb:</strong> play.
            </li>
          </ul>
          <p>
            Now let’s do a quiz to see if you can spot nouns & verbs on your own!
          </p>
        </>
      )
    }
  ]
};